

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card, Icon } from '@alpha/ink'

@Component({
  components: {
    Card,
    Icon
  }
})
export default class AudienceCard extends Vue {
  @Prop({ required: true }) readonly selected!: boolean
  @Prop({ required: true }) readonly header!: string
  @Prop({ required: true }) readonly body!: string
  @Prop({ required: true }) readonly showViewOrChange!: boolean
  @Prop({ default: false }) readonly loading!: boolean
  @Prop({ required: false }) readonly age?: string
  @Prop({ required: false }) readonly location?: string
}
